import { useState, useCallback } from 'react';

// Global state for new chat trigger
let newChatTriggers: (() => void)[] = [];
// Global state for chat reload trigger (without navigation)
let chatReloadTriggers: (() => void)[] = [];

export const useNewChatTrigger = () => {
  const [triggerCount, setTriggerCount] = useState(0);

  // Register a trigger function for new chat (with navigation)
  const registerTrigger = useCallback((triggerFn: () => void) => {
    newChatTriggers.push(triggerFn);
    return () => {
      newChatTriggers = newChatTriggers.filter(fn => fn !== triggerFn);
    };
  }, []);

  // Register a trigger function for chat reload (without navigation)
  const registerReloadTrigger = useCallback((reloadFn: () => void) => {
    chatReloadTriggers.push(reloadFn);
    return () => {
      chatReloadTriggers = chatReloadTriggers.filter(fn => fn !== reloadFn);
    };
  }, []);

  // Trigger all registered functions for new chat
  const triggerNewChat = useCallback(() => {
    newChatTriggers.forEach(trigger => trigger());
    setTriggerCount(prev => prev + 1);
  }, []);

  // Trigger all registered functions for chat reload
  const triggerChatReload = useCallback(() => {
    chatReloadTriggers.forEach(trigger => trigger());
    setTriggerCount(prev => prev + 1);
  }, []);

  return {
    registerTrigger,
    registerReloadTrigger,
    triggerNewChat,
    triggerChatReload,
    triggerCount,
  };
};
